module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.chooseProfile.title":"Choose Profile","views.chooseProfile.logout":"Logout","views.chooseProfile.login":"Choose"}}')
  delete Component.options._Ctor
}
